import type { Ref } from 'vue'

interface BreadcrumbItem {
  label: string
  path?: string
}

interface JsonLdListItem {
  '@type': 'ListItem'
  position: number
  item: {
    name: string
    '@id'?: string
  }
}

export const useBreadcrumbStructuredData = (breadcrumbsList: BreadcrumbItem[] | Ref<BreadcrumbItem[]>) => {
  const generateItemListElements = (breadcrumbs: BreadcrumbItem[]): JsonLdListItem[] => {
    if (!breadcrumbs || breadcrumbs.length === 0) {
      return []
    }

    return breadcrumbs.map((e, i) => {
      const isLastItem = i === breadcrumbs.length - 1

      // 最終階層以外は@idを含める
      const itemData: { name: string; '@id'?: string } = {
        name: e.label
      }

      if (!isLastItem && e.path) {
        const baseUrl = import.meta.env.ROOT_URL || 'https://machicon.jp'
        itemData['@id'] = baseUrl + e.path
      }

      const listItem: JsonLdListItem = {
        '@type': 'ListItem' as const,
        position: i + 1,
        item: itemData
      }

      return listItem
    })
  }

  const generateJsonData = (breadcrumbs: BreadcrumbItem[]): string | null => {
    const itemListElements = generateItemListElements(breadcrumbs)

    if (!itemListElements || itemListElements.length === 0) {
      return null
    }

    return JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: itemListElements
    })
  }

  const breadcrumbs = unref(breadcrumbsList)
  const jsonData = generateJsonData(breadcrumbs)

  if (jsonData) {
    useHead({
      script: [
        {
          type: 'application/ld+json',
          children: jsonData
        }
      ]
    })
  }
}
